import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { MAINTENANCE_DUE_STATUS } from 'src/constants/maintenance';

const MaintenanceDueStatusBadge = ({ status, className }) => {
  const { statusIcon, statusLabel } = MAINTENANCE_DUE_STATUS[status];

  return (
    <div className={`mnt-status-badge ${className}`}>
      <FontAwesomeIcon icon={statusIcon} />
      {statusLabel}
    </div>
  );
};

MaintenanceDueStatusBadge.propTypes = {
  status: PropTypes.oneOf(['overdue', 'warning', 'healthy']).isRequired,
  className: PropTypes.string,
};

MaintenanceDueStatusBadge.defaultProps = {
  className: '',
};

export default MaintenanceDueStatusBadge;
